import moment from 'moment';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import DashboardScreen from '../../screens/Dashboard/DashboardScreen';

const DashboardContainer = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({});
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  useEffect(() => {
    loadMockData();
  }, []);

  const loadMockData = () => {
    // Dados mockados baseados no PDF de relatório de faturamento
    const mockData = [
      {
        id: 1,
        code: 'S25102101',
        vehicle: 'VIRTUS - RFU6J67',
        mo_lataria: 2160.0,
        qtd_horas_lataria: 17.0,
        qtd_pecas_pintadas: 3.0,
        mo_estetica: 500.0,
        qtd_horas_estetica: 5.0,
        valor_pecas: 1747.6,
        custo_pecas: 1209.0,
        lucro_pecas: 538.6,
        total_os: 4407.6,
        status: 'Aberta',
        previsao_entrega: '17/09/2025',
        created_at: '01/09/2025',
      },
      {
        id: 2,
        code: 'S25102102',
        vehicle: 'VIRTUS - RFU6J68',
        mo_lataria: 4766.0,
        qtd_horas_lataria: 20.25,
        qtd_pecas_pintadas: 2.0,
        mo_estetica: 1154.2,
        qtd_horas_estetica: 10.0,
        valor_pecas: 80.0,
        custo_pecas: 80.0,
        lucro_pecas: 0.0,
        total_os: 6000.2,
        status: 'Fechada',
        previsao_entrega: '25/09/2025',
        data_fechamento: '30/09/2025',
        created_at: '02/09/2025',
      },
      {
        id: 3,
        code: 'S25102103',
        vehicle: 'VIRTUS - RFU6J69',
        mo_lataria: 7215.0,
        qtd_horas_lataria: 63.0,
        qtd_pecas_pintadas: 7.0,
        mo_estetica: 0.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 7529.94,
        custo_pecas: 3165.01,
        lucro_pecas: 4364.93,
        total_os: 14744.94,
        status: 'Quitada',
        previsao_entrega: '25/09/2025',
        data_fechamento: '30/09/2025',
        data_quitacao: '15/10/2025',
        created_at: '03/09/2025',
      },
      {
        id: 4,
        code: 'S25102105',
        vehicle: 'VIRTUS - RFU6J70',
        mo_lataria: 900.0,
        qtd_horas_lataria: 6.0,
        qtd_pecas_pintadas: 0.0,
        mo_estetica: 0.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 0.0,
        custo_pecas: 0.0,
        lucro_pecas: 0.0,
        total_os: 900.0,
        status: 'Aberta',
        previsao_entrega: '18/09/2025',
        created_at: '05/09/2025',
      },
      {
        id: 5,
        code: 'S25102107',
        vehicle: 'VIRTUS - RFU6J71',
        mo_lataria: 1950.0,
        qtd_horas_lataria: 13.0,
        qtd_pecas_pintadas: 2.0,
        mo_estetica: 374.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 220.0,
        custo_pecas: 220.0,
        lucro_pecas: 154.0,
        total_os: 2324.0,
        status: 'Fechada',
        previsao_entrega: '20/09/2025',
        data_fechamento: '28/09/2025',
        created_at: '07/09/2025',
      },
      {
        id: 6,
        code: 'S25102108',
        vehicle: 'VIRTUS - RFU6J72',
        mo_lataria: 3653.0,
        qtd_horas_lataria: 23.0,
        qtd_pecas_pintadas: 3.0,
        mo_estetica: 1347.48,
        qtd_horas_estetica: 10.0,
        valor_pecas: 0.0,
        custo_pecas: 0.0,
        lucro_pecas: 0.0,
        total_os: 5000.48,
        status: 'Quitada',
        previsao_entrega: '22/09/2025',
        data_fechamento: '29/09/2025',
        data_quitacao: '10/10/2025',
        created_at: '08/09/2025',
      },
      {
        id: 7,
        code: 'S25102109',
        vehicle: 'VIRTUS - RFU6J73',
        mo_lataria: 1850.0,
        qtd_horas_lataria: 13.5,
        qtd_pecas_pintadas: 2.0,
        mo_estetica: 956.58,
        qtd_horas_estetica: 0.0,
        valor_pecas: 441.91,
        custo_pecas: 441.91,
        lucro_pecas: 514.67,
        total_os: 2806.58,
        status: 'Aberta',
        previsao_entrega: '24/09/2025',
        created_at: '09/09/2025',
      },
      {
        id: 8,
        code: 'S25102110',
        vehicle: 'VIRTUS - RFU6J74',
        mo_lataria: 789.0,
        qtd_horas_lataria: 6.0,
        qtd_pecas_pintadas: 2.0,
        mo_estetica: 0.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 0.0,
        custo_pecas: 0.0,
        lucro_pecas: 0.0,
        total_os: 789.0,
        status: 'Fechada',
        previsao_entrega: '26/09/2025',
        data_fechamento: '30/09/2025',
        created_at: '10/09/2025',
      },
      {
        id: 9,
        code: 'S25102111',
        vehicle: 'VIRTUS - RFU6J75',
        mo_lataria: 450.0,
        qtd_horas_lataria: 4.0,
        qtd_pecas_pintadas: 1.0,
        mo_estetica: 0.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 0.0,
        custo_pecas: 0.0,
        lucro_pecas: 0.0,
        total_os: 450.0,
        status: 'Aberta',
        previsao_entrega: '27/09/2025',
        created_at: '11/09/2025',
      },
      {
        id: 10,
        code: 'S25102112',
        vehicle: 'VIRTUS - RFU6J76',
        mo_lataria: 975.0,
        qtd_horas_lataria: 6.5,
        qtd_pecas_pintadas: 1.0,
        mo_estetica: 0.0,
        qtd_horas_estetica: 0.0,
        valor_pecas: 0.0,
        custo_pecas: 0.0,
        lucro_pecas: 0.0,
        total_os: 975.0,
        status: 'Quitada',
        previsao_entrega: '28/09/2025',
        data_fechamento: '30/09/2025',
        data_quitacao: '12/10/2025',
        created_at: '12/09/2025',
      },
    ];

    setData(mockData);
  };

  return (
    <DashboardScreen
      data={filteredData(data, filter)}
      company={company}
      user={user}
      filter={filter}
      setFilter={setFilter}
    />
  );
};

export default DashboardContainer;

const filteredData = (data, filter) => {
  return data.filter((item) => doFilter(item, filter));
};

const doFilter = (item, filter) => {
  let isSearch = true;
  if (filter && filter.search) {
    isSearch =
      item?.code?.toLowerCase().includes(filter.search.toLowerCase()) ||
      item?.vehicle?.toLowerCase().includes(filter.search.toLowerCase());
  }

  let isDates = true;
  if (filter && filter.dates && filter.dates[0] && filter.dates[1]) {
    const startDate = moment(filter.dates[0]);
    const endDate = moment(filter.dates[1]);
    const itemDate = moment(item.created_at, 'DD/MM/YYYY');
    isDates =
      moment(itemDate).isBetween(
        moment(startDate),
        moment(endDate).add(23, 'h')
      ) ||
      moment(itemDate).isSame(startDate) ||
      moment(itemDate).isSame(endDate);
  }

  let isStatus = true;
  if (filter && filter.status && filter.status.value) {
    isStatus = item.status === filter.status.value;
  }

  return isSearch && isDates && isStatus;
};
